var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3266 19.6734C1.89113 19.2379 1.89113 18.5319 2.3266 18.0964L18.0964 2.3266C18.5319 1.89113 19.2379 1.89113 19.6734 2.3266C20.1089 2.76207 20.1089 3.46811 19.6734 3.90358L3.90358 19.6734C3.46811 20.1089 2.76207 20.1089 2.3266 19.6734Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6734 19.6734C19.2379 20.1089 18.5319 20.1089 18.0964 19.6734L2.3266 3.90358C1.89113 3.46811 1.89113 2.76207 2.3266 2.3266C2.76207 1.89113 3.46811 1.89113 3.90358 2.3266L19.6734 18.0964C20.1089 18.5319 20.1089 19.2379 19.6734 19.6734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5f3ee2287a8d321479e913bcd433e71c.svg";
export { ForwardRef as ReactComponent };